import * as z from 'zod';

export const shipSchema = z.object({
  name: z.string().nullable(),
  mmsi: z.string().nullable(),
  callSign: z.string().nullable(),
  imo: z.union([z.string(), z.number()]).nullable(),
  type: z.string().nullable(),
});

export type Ship = z.infer<typeof shipSchema>;
